const HS_ID = process.env.REACT_APP_HUBSPOT_ID;

let _disabled_ = false;
let _initialized_: boolean;
export const initialize = (disable = false) => {
  if (document.cookie.indexOf('hubspotutk=') === -1 && disable) {
    window._hsq?.push(['doNotTrack']);
    _initialized_ = false;
    return;
  } else if (document.cookie.indexOf('hubspotutk=') !== -1 && disable) {
    window._hsq?.push(['revokeCookieConsent']);
    setTimeout(() => window._hsq?.push(['doNotTrack']), 400);
    _initialized_ = false;

    return;
  }

  if (!HS_ID) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        `[HUBSPOT] to enable HubSpot in dev time add 'REACT_APP_HUBSPOT_ID='{dev_token_here}'' to '.env.development.local' file`
      );
    }
    return;
  }

  _disabled_ = disable;

  if (_initialized_) {
    return;
  }
  _initialized_ = false;

  function initialize(doc: Document, hubspot: string) {
    const a = doc.createElement('script');
    const m = doc.getElementsByTagName('script')[0];
    a.id = 'hs-script-loader';
    a.async = true;
    a.defer = true;
    a.src = hubspot;
    m.parentNode?.insertBefore(a, m);
    _initialized_ = true;

    if (window._hsq && !disable) {
      window._hsq.push(['doNotTrack', { track: true }]);
      // reload so that hubspotutk cookie gets set correctly
      window.location.reload();
    }
  }
  initialize(document, `//js.hs-scripts.com/${HS_ID}.js`);
};

export const sendPageView = (pageName: string) => {
  if (HS_ID && window._hsq && !_disabled_) {
    window._hsq.push(['setPath', pageName]);
    window._hsq.push(['trackPageView']);
  }
};

export const hubSpot = {
  initialize,
  sendPageView,
};
